import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../../assets/images/logo.png";
import "./style.css";
import countries from "./countries";
import CreditWarning from "./buycredit";
import avatar from "../../../assets/images/profile.jpg";
import { Tooltip } from "react-tooltip";

const Bycall = ({ showModal, handleModalClose, data = {}, expert }) => {
  const [iframeShow, setIframeShow] = useState(false);
  const [iframeData, setIframeData] = useState({});
  const [countryList, setCountryList] = useState([]);
  const [showCreditWarning, setShowCreditWarning] = useState(false);
  const [languageData, setLanguageData] = useState(null);

  const [userCountryCode, setUserCountryCode] = useState(null);
  const [countryFound, setCountryFound] = useState(false);
  const [showNotAvailable, setShowNotAvailable] = useState(false);
  const [canShowDropdown, setCanShowDropdown] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [userManuallyChanged, setUserManuallyChanged] = useState(false);
  const isInIframe = window !== window.parent;

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../../lang/by-call/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);
  useEffect(() => {
    const getUserCountry = async () => {
      const cached = localStorage.getItem("userCountry");

      if (cached) {
        const parsed = JSON.parse(cached);
        setUserCountryCode(parsed.country?.toLowerCase());
        return;
      }

      try {
        const ipRes = await fetch("https://api.ipify.org?format=json");
        const ipData = await ipRes.json();

        const lookupRes = await fetch(
          "https://builder.leadsy.pro/lookup_api/v1/" + ipData.ip,
        );

        const lookupData = await lookupRes.json();
        const data = lookupData?.data;

        const country = data?.country || "us";

        const result = {
          ip: data?.ip || ipData.ip,
          city: data?.city || "Unknown City",
          region: data?.region || "Unknown Region",
          country,
          timezone:
            data?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        localStorage.setItem("userCountry", JSON.stringify(result));

        setUserCountryCode(country.toLowerCase());
      } catch (e) {
        setUserCountryCode("us");
      }
    };

    getUserCountry();
  }, []);

  const handleClose = () => {
    if (isInIframe) {
      setIframeShow(false);
      window.parent.postMessage({ type: "CLOSE_MODAL" }, "*");
    } else {
      handleModalClose();
    }
  };

  useEffect(() => {
    if (isInIframe) {
      const handleMessage = (event) => {
        if (event.data.type === "SHOW_MODAL") {
          const receivedData = event.data.data;
          const processedData = {
            ...receivedData,
          };
          setIframeShow(true);
          setIframeData(processedData);
        }
      };
      window.addEventListener("message", handleMessage);
      return () => window.removeEventListener("message", handleMessage);
    }
  }, []);

  useEffect(() => {
    if (data?.usercredit && data?.max) {
      if (data.usercredit < data.max) {
        setShowCreditWarning(true);
      } else {
        setShowCreditWarning(false);
      }
    }
  }, [data]);

  const handleCountryChange = (flag) => {
    const selected = countryList.find((c) => c.flag === flag);

    if (selected) {
      setSelectedCountry(selected);
      setUserManuallyChanged(true);
    }
  };

  useEffect(() => {
    if (!data?.services) return;

    const service = data.services.find((s) => s.call_type === "prn");
    if (!service?.channels?.length) return;

    setCanShowDropdown(true);

    const restrictions = service.restrictions?.toLowerCase() || "opened";
    const lang = process.env.REACT_APP_LANG || "en";

    const countriesData = service.channels.map((channel) => {
      const countryCode = channel.country?.toLowerCase();
      const countryInfo = countries[countryCode];

      return {
        name: countryInfo?.[lang] || channel.country,
        flag: countryCode,
        phone: channel.data,
        billing: channel.billing,
      };
    });

    setCountryList(countriesData);

    const matched = countriesData.find((c) => c.flag === userCountryCode);

    if (userManuallyChanged) return;

    if (restrictions === "opened") {
      setSelectedCountry(matched || null);
    }

    if (restrictions === "restricted") {
      setSelectedCountry(matched || null);

      if (!matched) setShowNotAvailable(true);
    }
  }, [data, userCountryCode]);

  const hasSelection = !!selectedCountry?.flag;
  const phoneToDisplay = selectedCountry?.phone || "";
  if (!languageData) {
    return;
  }
  const service = data.services.find((s) => s.call_type === "prn");

  const BulletPoint = () => (
    <div className="me-2 d-flex align-items-center justify-content-center bullet-container">
      <div className="bullet-outer">
        <div className="bullet-middle">
          <div className="bullet-inner"></div>
        </div>
      </div>
    </div>
  );

  return (
    <Modal
      show={showModal}
      onHide={handleModalClose}
      dialogClassName="custom-modal-dialog"
      centered
    >
      <Modal.Header closeButton className="modal-header-gradient">
        <img
          src={logo}
          alt="Logo"
          style={{ height: "12px", marginRight: "auto" }}
        />
      </Modal.Header>
      <Modal.Body className="p-0">
        {!showNotAvailable && (
          <div className="card_body">
           <div className="d-flex flex-column align-items-center justify-content-center p-3 body-section-gradient position-relative">
            <div className="d-flex align-items-center justify-content-center">
              <div className="position-relative me-3">
                <img
                  src={expert?.image || avatar}
                  alt={expert?.nickname || ""}
                  className="rounded-circle profile-image"
                />
                <span
                  className="status-unavailable"
                  /* {`position-absolute status-indicator ${
                expert.status === "available"
                  ? "status-available"
                  : "status-unavailable"
              }`} */
                />
              </div>
              <div>
                <p className="mb-0 consultant-header">
                  {languageData.header.title}
                </p>
                <p className="mb-0 consultant-name">
                  {expert?.nickname ? expert.nickname.toUpperCase() : ""}{" "}
                </p>
              </div>
            </div>
            {service?.code && (
              <div className="flex justify-content-end code_expert">
                <span
                  data-tooltip-id="code_expert_tooltip"
                  data-tooltip-content={languageData.content.code_expert_tooltip}
                 data-tooltip-place="bottom"
                 >
                  {languageData.content.code}{" "}
                  <small className="code fs-13 fw-600">{service.code}</small>
                </span>
                  <Tooltip id="code_expert_tooltip" />
              </div>
            )}
 </div> 
            
            <div className="text-center pt-4">
              <div className="d-flex align-items-center justify-content-center">
                <div className="dropdown_block mb-4">
                  <p
                    className="info-text d-inline-block mb-0 fs-16"
                    style={{ color: "#777" }}
                  >
                    {languageData.content.title}
                  </p>
                  {canShowDropdown ? (
                    // countryList.length > 1 ? (
                    <Dropdown
                      className="d-inline-block ml-2"
                      onSelect={handleCountryChange}
                    >
                      <Dropdown.Toggle
                        variant="light"
                        className="country-dropdown"
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          boxShadow: "none",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          padding: "0",
                          height: "30px",
                          lineHeight: "24px",
                        }}
                      >
                        {selectedCountry ? (
                          <>
                            <div
                              style={{
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                overflow: "hidden",
                                marginRight: "8px",
                                backgroundColor: "#fff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                alt={selectedCountry.name}
                                src={`assets/images/flags/${selectedCountry.flag}.png`}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>

                            {selectedCountry.name}
                          </>
                        ) : (
                          <>
                            {/* NO COUNTRY STATE */}
                            <svg
                              className="noCountry"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20px"
                              style={{ marginRight: "8px" }}
                            >
                              <circle cx="12" cy="12" r="9" stroke="#6c4f45" />
                              <path
                                d="M12 3C12 3 8.5 6 8.5 12C8.5 18 12 21 12 21"
                                stroke="#6c4f45"
                              />
                              <path
                                d="M12 3C12 3 15.5 6 15.5 12C15.5 18 12 21 12 21"
                                stroke="#6c4f45"
                              />
                              <path d="M3 12H21" stroke="#6c4f45" />
                            </svg>

                            <span className="ml-6 font-14 brownColor">
                              {languageData.content.select_country}
                            </span>
                          </>
                        )}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {(countryFound
                          ? [
                              selectedCountry,
                              ...countryList.filter(
                                (c) => c.flag !== selectedCountry.flag,
                              ),
                            ]
                          : countryList
                        ).map((country) => (
                          <Dropdown.Item
                            key={country.name}
                            eventKey={country.flag}
                          >
                            <div className="d-flex align-items-center">
                              <div
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  borderRadius: "50%",
                                  overflow: "hidden",
                                  display: "inline-block",
                                  marginRight: "10px",
                                  backgroundColor: "#fff",
                                }}
                              >
                                <img
                                  alt={`${country.name} flag`}
                                  src={`assets/images/flags/${country.flag}.png`}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    display: "block",
                                  }}
                                />
                              </div>
                              {country.name}
                            </div>
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    selectedCountry?.name && (
                      <div className="d-inline-block ml-2">
                        <div
                          className="country-dropdown"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%",
                              overflow: "hidden",
                              marginRight: "8px",
                              backgroundColor: "#fff",
                            }}
                          >
                            <img
                              alt={`${selectedCountry.name} flag`}
                              src={`assets/images/flags/${selectedCountry.flag}.png`}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                          {selectedCountry.name}
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>

            <div className="text-center mb-4">
              <div className="d-flex justify-content-center align-items-center mb-2">
                <div className="rounded-circle d-flex justify-content-center align-items-center me-3 phone-icon-container">
                  <i
                    className="ri-phone-fill"
                    style={{ color: "white", fontSize: "30px" }}
                  ></i>
                </div>
                <div style={{ textAlign: "left" }}>
                  {phoneToDisplay ? (
                    <h2 className="mb-0 phone-call">{phoneToDisplay}</h2>
                  ) : (
                    <h2 className="mb-0 blur_number">
                    0698765462
                    </h2>
                  )}

                  {selectedCountry?.billing && (
                    <p className="phone-charge-text fs-12">
                      {selectedCountry.billing} {languageData.content.subtitle}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center align-items-center">
              <div className="mx-3 mb-3 p-3 info-box">
                <div className="mb-3 d-flex align-items-start">
                  <BulletPoint />
                  <span className="info-text">
                    {languageData.content.lines.line1.title}
                  </span>
                </div>
                <div className="mb-3 d-flex align-items-start">
                  <BulletPoint />
                  <span className="info-text">
                    {languageData.content.lines.line2.title}
                  </span>
                </div>
                <div className="mb-3 d-flex align-items-start">
                  <BulletPoint />
                  <span className="info-text">
                    {languageData.content.lines.line3.title}{" "}
                  </span>
                </div>
                <div className="mb-0 d-flex align-items-start">
                  <BulletPoint />
                  <span className="info-text">
                    {languageData.content.lines.line4.title}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
        {showNotAvailable && (
           <div className="card_body">
            <div className="d-flex align-items-center justify-content-center p-3 body-section-gradient">
              <div className="position-relative me-3">
                <img
                  src={expert?.image || avatar}
                  alt={expert?.nickname || ""}
                  className="rounded-circle profile-image"
                />
                <span
                  className="status-unavailable"
                  /* {`position-absolute status-indicator ${
                expert.status === "available"
                  ? "status-available"
                  : "status-unavailable"
              }`} */
                />
              </div>
              <div>
                <p className="mb-0 consultant-header">
                  {languageData.header.title}
                </p>
                <p className="mb-0 consultant-name">
                  {expert?.nickname ? expert.nickname.toUpperCase() : ""}{" "}
                </p>
              </div>
            </div>
          <div class="flex flex-column not_available">
            <svg
              width="90"
              height="90"
              viewBox="0 0 90 90"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="45"
                cy="45"
                r="42"
                fill="#fff3ef"
                stroke="#fde8e0"
                stroke-width="1.5"
              />
              <circle
                cx="45"
                cy="45"
                r="28"
                fill="none"
                stroke="#fdd0c0"
                stroke-width="1"
                stroke-dasharray="4 3"
              />
              <ellipse
                cx="45"
                cy="45"
                rx="12"
                ry="28"
                fill="none"
                stroke="#fdd0c0"
                stroke-width="1"
              />
              <line
                x1="17"
                y1="45"
                x2="73"
                y2="45"
                stroke="#fdd0c0"
                stroke-width="1"
              />
              <line
                x1="45"
                y1="17"
                x2="45"
                y2="73"
                stroke="#fdd0c0"
                stroke-width="1"
              />
              <circle cx="45" cy="36" r="9" fill="#e8541a" />
              <path
                d="M45 45C38 45 32 50 32 56L45 63L58 56C58 50 52 45 45 45Z"
                fill="#e8541a"
                opacity="0.5"
              />
              <line
                x1="22"
                y1="72"
                x2="68"
                y2="72"
                stroke="#fdd0c0"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            <div class="flex align-items-center noCountryAvailable ">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                width="14px"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
                    fill="#ee6039"
                  ></path>
                  <path
                    d="M12 5C11.4477 5 11 5.44771 11 6V12.4667C11 12.4667 11 12.7274 11.1267 12.9235C11.2115 13.0898 11.3437 13.2343 11.5174 13.3346L16.1372 16.0019C16.6155 16.278 17.2271 16.1141 17.5032 15.6358C17.7793 15.1575 17.6155 14.5459 17.1372 14.2698L13 11.8812V6C13 5.44772 12.5523 5 12 5Z"
                    fill="#ee6039"
                  ></path>
                </g>
              </svg>
              <span>{languageData.content.service_indisponible}</span>
            </div>
          </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Bycall;
